export const CardLocationInfo = ({ location }) => {
  return (
    <div className="info-item d-flex align-items-center mb-2">
      <i className="fas fa-location-dot mr-2" style={{ fontSize: "12px" }} />
      <span
        className="info-text"
        style={{ fontSize: "0.85rem", color: "#495057" }}
      >
        {location || "N/A"}
      </span>
    </div>
  );
};
